import React, { useState } from "react";

import Button from "../../Button";
import Label from "../../Label";
import Title from "../../Title";

import { numberWithCommas } from "../../../util";
import { BlackDetailIcon, CloseBlackIcon } from "@assets/svgs";
import { Loader } from "../../Loader";

import "./style.scss";

export function TalentJobMetrics({
  total_jobs,
  total_clients,
  total_talent,
  total_proposals,
}) {
  const [showIntro, setShowIntro] = useState(false);

  const onToggle = () => {
    setShowIntro(!showIntro);
  };

  const isLoading = !total_clients && !total_jobs && !total_talent && !total_proposals;

  return (
    <div
      className="community-metrics"
      data-aos="fade-up"
      data-aos-delay="50"
    >
      <div
        className={`community-metrics__main community-metrics__main--${
          showIntro ? "hide" : "show"
        }`}
      >
        <div className="community-metrics__header">
          <Title type="primary" size="medium" font="medium">
            Community metrics
          </Title>
          <Button
            styles="community-metrics__detail-button"
            onClick={onToggle}
          >
            <BlackDetailIcon className="icon__detail" />
          </Button>
        </div>
        {isLoading && <Loader className="community-metrics__loader" />}
        {!isLoading && (
          <div className="community-metrics__content">
              <div className="community-metrics__item">
                <Label
                  type="primary"
                  size="large"
                  font="medium"
                >
                  Total jobs
                </Label>

                <Title type="primary" font="medium" size="large">
                  {total_jobs ? numberWithCommas(total_jobs) : "N/A"}
                </Title>
              </div>

              <div className="community-metrics__item">
                <Label
                  type="primary"
                  size="large"
                  font="medium"
                >
                  Total clients
                </Label>

                <Title type="primary" font="medium" size="large">
                  {total_clients ? numberWithCommas(total_clients) : "N/A"}
                </Title>
              </div>

              <div className="community-metrics__item">
                <Label
                  type="primary"
                  size="large"
                  font="medium"
                >
                  Community members
                </Label>

                <Title type="primary" font="medium" size="large">
                  {total_talent ? numberWithCommas(total_talent) : "N/A"}
                </Title>
              </div>

              <div className="community-metrics__item">
                <Label
                  type="primary"
                  size="large"
                  font="medium"
                >
                  Talent applications
                </Label>

                <Title type="primary" font="medium" size="large">
                  {total_proposals ? numberWithCommas(total_proposals) : "N/A"}
                </Title>
              </div>
          </div>
        )}
      </div>
      <div
        className={`community-metrics__intro community-metrics__intro--${
          showIntro ? "show" : "hide"
        }`}
      >
        <div className="community-metrics__header">
          <Title type="primary" size="medium" font="medium">
            Definitions
          </Title>
          <Button
            styles="community-metrics__detail-button"
            onClick={onToggle}
          >
            <CloseBlackIcon className="icon__detail" />
          </Button>
        </div>
        <div className="community-metrics__intro-content">
          <div>
            <Label type="primary" size="large" font="medium">
              Total Jobs
            </Label>
            <Label type="primary" size="medium">
              The total number of jobs that have been posted on the Braintrust
              platform.
            </Label>
          </div>
          <div>
            <Label type="primary" size="large" font="medium">
              Community Members
            </Label>
            <Label type="primary" size="medium">
              The total number of community members on the Braintrust platform,
              including verified and not-yet verified talent and community
              members who aren't actively seeking a new opportunity.
            </Label>
          </div>
          <div>
            <Label type="primary" size="large" font="medium">
              Talent Applications
            </Label>
            <Label type="primary" size="medium">
              The total number of aplications that have been submitted by
              Braintrust talent.
            </Label>
          </div>
        </div>
      </div>
    </div>
  );
}
